import React, { FC, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useNavigate, useParams } from "react-router-dom";
import services from "utils/services";
import { Link } from "react-router-dom";
import { string, object } from "yup";
import ShiftForm from "components/Forms/ShiftForm";

export interface ShiftEditProps {
	className?: string;
}

const ShiftEdit: FC<ShiftEditProps> = ({ className = "" }) => {
	const [shift, setShift] = useState<any>({});
	const [isEdit, setIsEdit] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);
	const [errors, setErrors] = useState<any>({});

	const navigate = useNavigate();

	const getShiftSchema = () => {
		return object({
			name: string().required(""),
			// password: user._id ? string().notRequired() : string().required(""),
			// email: string().required("").email("Email invalide"),
			// role: mixed().oneOf(["ADMIN", "ASSISTANT", "MANAGER"], "").required(""),
		});
	};

	const { shiftId } = useParams();
	useEffect(() => {
		if (shiftId) {
			services.getOneShift(
				shiftId,
				(success) => {
					setShift({
						...success.shift,
					});
					setIsEdit(true);
				},
				(error) => {}
			);
		}
	}, [shiftId]);

	const checkFields = () => {
		let fieldErrors: any = {};
		try {
			getShiftSchema().validateSync(shift, { abortEarly: false });
			setErrors({});
			return true;
		} catch (err: any) {
			console.log(err);
			err.inner?.forEach((oneErr: { path: string; message: string }) => {
				fieldErrors[oneErr.path] = oneErr.message;
			});
			setErrors(fieldErrors);
			return false;
		}
	};

	const saveShift = () => {
		const isValid = checkFields();
		if (isValid) {
			console.log({ shift });
			setLoading(true);
			services.saveShift(
				shift,
				(success) => {
					navigate(-1);
					setLoading(false);
				},
				(error) => {
					setLoading(false);

					if (error.response.status == 422) {
						// errors.email = error.response.data.message;
					} else {
						// errors.global = "Une erreur est survenue";
					}

					// setErrors({ ...errors });
					console.log(error);
				}
			);
		}
	};

	return (
		<div className={`nc-Edit ${className} container`} data-nc-id="Edit">
			{/* <Helmet>
				<title>SHIFT || IRIS GALERIE MAROC</title>
			</Helmet> */}

			<div className="mt-10 flex flex-col sm:w-[70%] justify-center ml-auto mr-auto">
				<Link
					onClick={() => navigate(-1)}
					className="w-10 h-10 sm:w-12 sm:h-12 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full  flex items-center justify-center text-right"
					to={"#"}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth={1.5}
						stroke="currentColor"
						className="w-6 h-6"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
						/>
					</svg>
				</Link>
				<div className="space-y-10 sm:space-y-12">
					{/* HEADING */}
					<h2 className="text-2xl sm:text-3xl font-semibold">
						{isEdit && shift ? (
							<>
								<div className="text-sm">Modification</div> {shift.name}
							</>
						) : (
							"Nouveau Shift"
						)}
					</h2>
					<div className="">
						<ShiftForm shift={shift} setShift={setShift} errors={errors} />
						<div className="my-5 pt-2 text-center w-full">
							<ButtonPrimary
								onClick={() => saveShift()}
								loading={loading}
								disabled={loading}
								className=" w-full"
							>
								Valider
							</ButtonPrimary>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ShiftEdit;
